import { useRef, useState } from 'react';
import { prepareFiles } from '../../lib/file-size';

interface FileInputProps {
	onFiles: (files: File[]) => void;
	accept?: string;
	multiple?: boolean;
	children: (props: { open: () => void; converting: boolean }) => React.ReactNode;
}

export function FileInput({ onFiles, accept, multiple, children }: FileInputProps) {
	const inputRef = useRef<HTMLInputElement>(null);
	const [converting, setConverting] = useState(false);

	const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const selected = Array.from(e.target.files ?? []);
		if (!selected.length) return;
		e.target.value = '';

		setConverting(true);
		try {
			const valid = await prepareFiles(selected, accept);
			if (valid.length) onFiles(valid);
		} finally {
			setConverting(false);
		}
	};

	return (
		<>
			<input
				ref={inputRef}
				type="file"
				accept={accept}
				multiple={multiple}
				className="hidden"
				onChange={handleChange}
			/>
			{children({
				open: () => inputRef.current?.click(),
				converting,
			})}
		</>
	);
}
